import { ReducersMapObject, combineReducers, Reducer } from "redux";
import { History } from "history";

import { authenticationReducer } from "@montana/containers/authentication/authentication.reducer";
import { cartReducer } from "@montana/containers/cart/cart.reducer";
import { createRouterReducer } from "@montana/containers/router/router.reducers";
import { filterReducer } from "@montana/containers/filter/filter.reducer";
import { notificationReducer } from "@montana/containers/notification/notification.reducers";
import { pageReducer } from "@montana/containers/page/page.reducers";
import { productReducer } from "@montana/containers/product/product.reducer";
import { settingsReducer } from '@montana/containers/settings/settings.reducers';
import { siteStructureReducer } from "@montana/containers/site-structure/site-structure.reducers";
import { translationsReducer } from "@montana/containers/translations/translations.reducers";
import { checkoutReducer } from "@montana/containers/checkout/checkout.reducer";

import { IStoreState } from "./store";
import { storesReducer } from "@montana/containers/stores/stores.reducers";
import { dynamicSettingsReducer } from "@montana/containers/dynamic-settings/dynamic-settings.reducer";

const rootReducer = {
    authentication: authenticationReducer,
    cart: cartReducer,
    filter: filterReducer,
    notification: notificationReducer,
    page: pageReducer,
    product: productReducer,
    settings: settingsReducer,
    siteStructure: siteStructureReducer,
    translations: translationsReducer,
    checkout: checkoutReducer,
    stores: storesReducer,
    dynamicSettings: dynamicSettingsReducer
} as ReducersMapObject<IStoreState>;

export const createRootReducer = (history: History): Reducer => combineReducers({
    ...rootReducer,
    router: createRouterReducer(history),
});
